export default "__VITE_ASSET__3d27e0ca__"